(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const mq = window.matchMedia(MOBILE_QUERY);
  let stickyBar = null;
  let stickyButton = null;
  let sourceButton = null;
  let rootObserver = null;
  let buttonObserver = null;
  let labelObserver = null;
  let scheduled = false;
  const SCROLL_THRESHOLD = 260;

  const getSourceButton = () =>
    document.querySelector('product-info .product-form__submit[name="add"]');

  const getButtonLabel = (button) => {
    if (!button) return '';
    const labelNode = button.querySelector('span');
    if (!labelNode) return '';
    return labelNode.textContent.trim().replace(/\s+/g, ' ');
  };

  const createStickyBar = () => {
    if (stickyBar) return;
    stickyBar = document.createElement('div');
    stickyBar.className = 'sticky-atc-mobile';
    stickyBar.hidden = false;

    stickyButton = document.createElement('button');
    stickyButton.type = 'button';
    stickyButton.className = 'sticky-atc-mobile__button';
    stickyButton.textContent = 'Adauga in cos';

    stickyButton.addEventListener('click', () => {
      if (!sourceButton || sourceButton.disabled) return;
      sourceButton.click();
    });

    stickyBar.appendChild(stickyButton);
    document.body.appendChild(stickyBar);
  };

  const disconnectButtonObservers = () => {
    if (buttonObserver) buttonObserver.disconnect();
    if (labelObserver) labelObserver.disconnect();
    buttonObserver = null;
    labelObserver = null;
  };

  const attachButtonObservers = () => {
    if (!sourceButton) return;
    disconnectButtonObservers();

    buttonObserver = new MutationObserver(() => scheduleSync());
    buttonObserver.observe(sourceButton, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
    });

    const labelNode = sourceButton.querySelector('span');
    if (labelNode) {
      labelObserver = new MutationObserver(() => scheduleSync());
      labelObserver.observe(labelNode, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  };

  const syncStickyState = () => {
    const nextSourceButton = getSourceButton();
    const sourceChanged = nextSourceButton !== sourceButton;
    sourceButton = nextSourceButton;

    if (!mq.matches || !sourceButton) {
      if (stickyBar) stickyBar.classList.remove('is-visible');
      document.body.classList.remove('has-mobile-sticky-atc');
      disconnectButtonObservers();
      return;
    }

    createStickyBar();
    document.body.classList.add('has-mobile-sticky-atc');

    const label = getButtonLabel(sourceButton);
    if (label) stickyButton.textContent = label;
    stickyButton.disabled = sourceButton.disabled;

    const sourceRect = sourceButton.getBoundingClientRect();
    const isSourceInViewport = sourceRect.top < window.innerHeight && sourceRect.bottom > 0;
    const shouldShow = window.scrollY > SCROLL_THRESHOLD && !isSourceInViewport;
    stickyBar.classList.toggle('is-visible', shouldShow);

    if (sourceChanged) attachButtonObservers();
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      syncStickyState();
    });
  };

  const startRootObserver = () => {
    if (rootObserver) return;
    const root = document.querySelector('product-info');
    if (!root) return;

    rootObserver = new MutationObserver(() => {
      scheduleSync();
    });

    rootObserver.observe(root, {
      childList: true,
    });
  };

  const init = () => {
    syncStickyState();
    startRootObserver();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', scheduleSync);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(scheduleSync);
  }

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync);
})();
